import { useEffect, useState } from 'react'

/**
 * Il valore, ma aggiornato solo dopo che smette di cambiare per `ritardoMs`: la ricerca
 * per testo non deve interrogare il server a ogni tasto.
 * @param {T} valore - Il valore che cambia
 * @param {number} [ritardoMs] - Quanto aspettare
 * @returns {T} Il valore "calmo"
 * @template T
 */
export const useRitardato = (valore, ritardoMs = 300) => {
  const [calmo, setCalmo] = useState(valore)
  useEffect(() => {
    const timer = setTimeout(() => setCalmo(valore), ritardoMs)
    return () => clearTimeout(timer)
  }, [valore, ritardoMs])
  return calmo
}
